import { render } from "./FlashNotice.vue?vue&type=template&id=1ff930f6&ts=true"
import script from "./FlashNotice.vue?vue&type=script&lang=ts"
export * from "./FlashNotice.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__